// Fits every stencil slide of the gallery to its square: the stencil is drawn 1024 px wide and scaled to the slide,
// a stencil taller than its square shrinks until it fits. The CSS carries a fallback for the scale, not for the fit.
(function () {
  var BASE = 1024;
  function fit(slide) {
    var stencil = slide.querySelector(':scope > .hh-pdp-scale');
    if (!stencil || slide.clientWidth === 0) return;
    stencil.style.setProperty('--hh-scale', (slide.clientWidth / BASE).toFixed(5));
    var height = stencil.scrollHeight;
    stencil.style.setProperty('--hh-fit', height > BASE + 2 ? (BASE / height).toFixed(4) : '1');
  }
  function start() {
    var slides = document.querySelectorAll('.product-gallery__media-slide--stencil');
    if (slides.length === 0) return;
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) { entries.forEach(function (entry) { fit(entry.target); }); }) : null;
    slides.forEach(function (slide) {
      fit(slide);
      if (observer) observer.observe(slide);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { slides.forEach(fit); });
  }
  // The enlarged view of the gallery (core 0.19) copies each slide into a square of its own size: fit those copies too.
  document.addEventListener('gallery:zoom', function (event) {
    var dialog = event.detail && event.detail.dialog;
    if (dialog) dialog.querySelectorAll('.product-gallery__media-slide--stencil').forEach(fit);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
